import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";
import { Link } from "react-router-dom";

const SignUpLayer = () => {
  return (
    <section className="auth min-vh-100 d-flex justify-content-center align-items-center bg-primary-600">
      <style>
        {`
          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .auth-card {
            animation: fadeInUp 0.6s ease-out;
          }
          .form-control:focus {
            border-color: #364E3D !important;
            box-shadow: 0 0 0 3px rgba(54, 78, 61, 0.1) !important;
            background-color: #fff !important;
          }
          input:-webkit-autofill,
          input:-webkit-autofill:hover, 
          input:-webkit-autofill:focus, 
          input:-webkit-autofill:active {
            -webkit-box-shadow: 0 0 0 30px #f5f6fa inset !important;
            -webkit-text-fill-color: #111827 !important;
          }
        `}
      </style>

      <div
        className="auth-card bg-white radius-16 p-32 p-sm-40 shadow-lg text-center mx-3"
        style={{ maxWidth: "450px", width: "100%" }}
      >
        <div className="mb-32">
          <Link to="/" className="d-inline-block mb-24">
            <img
              src="/assets/images/logo.png"
              alt="Logo"
              style={{ maxHeight: "120px", width: "auto", objectFit: "contain" }}
            />
          </Link>
          <h4 className="mb-12 fw-bold text-dark">Create Account</h4>
          <p className="text-secondary-light text-md">
            Enter your details to register as a partner
          </p>
        </div>

        <form action="#">
          <div className="icon-field mb-20 text-start">
            <label className="form-label text-secondary text-sm fw-medium mb-8">
              Full Name
            </label>
            <div className="position-relative">
              <span className="icon top-50 translate-middle-y start-0 auth-icon-left text-secondary-light">
                <Icon icon="f7:person" className="text-xl" />
              </span>
              <input
                type="text"
                className="form-control h-56-px bg-neutral-50 radius-12"
                style={{ paddingLeft: "48px" }}
                placeholder="Enter Full Name"
              />
            </div>
          </div>

          <div className="icon-field mb-20 text-start">
            <label className="form-label text-secondary text-sm fw-medium mb-8">
              Email Address
            </label>
            <div className="position-relative">
              <span className="icon top-50 translate-middle-y start-0 auth-icon-left text-secondary-light">
                <Icon icon="mage:email" className="text-xl" />
              </span>
              <input
                type="email"
                className="form-control h-56-px bg-neutral-50 radius-12"
                style={{ paddingLeft: "48px" }}
                placeholder="Enter Email"
              />
            </div>
          </div>

          <div className="icon-field mb-24 text-start">
            <label className="form-label text-secondary text-sm fw-medium mb-8">
              Password
            </label>
            <div className="position-relative">
              <span className="icon top-50 translate-middle-y start-0 auth-icon-left text-secondary-light">
                <Icon icon="solar:lock-password-outline" className="text-xl" />
              </span>
              <input
                type="password"
                className="form-control h-56-px bg-neutral-50 radius-12"
                style={{ paddingLeft: "48px" }}
                placeholder="Create Password"
              />
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg w-100 radius-12 h-56-px fw-semibold"
            style={{ backgroundColor: "#364E3D", borderColor: "#364E3D" }}
          >
            Sign Up
          </button>

          <div className="mt-32 text-center text-sm">
            <p className="mb-0">
              Already have an account?{" "}
              <Link to="/sign-in" className="text-primary-600 fw-bold">
                Sign In
              </Link>
            </p>
          </div>
        </form>
      </div>
    </section>
  );
};

export default SignUpLayer;
